import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Zap, Lock, Infinity as InfinityIcon, ShieldCheck, ShoppingBag } from "lucide-react";
import BookCover from "@/components/landing/BookCover";
import { SHOPIFY_CHECKOUT } from "@/lib/shopify";

const EASE = [0.16, 1, 0.3, 1];

const PRODUCTS = {
  memorisation: {
    covers: ["mem"],
    title: "Guide de mémorisation",
    sub: "Le plan de 6 mois",
    price: "29,99 €",
  },
  revision: {
    covers: ["rev"],
    title: "Guide de révision",
    sub: "Le plan de 30 jours",
    price: "24,99 €",
  },
  "pack-complet": {
    covers: ["mem", "rev"],
    title: "Pack Gold",
    sub: "Mémorisation + révision",
    price: "44,99 €",
    oldPrice: "54,98 €",
  },
};

export default function CheckoutPage() {
  const [params] = useSearchParams();
  const id = PRODUCTS[params.get("produit")] ? params.get("produit") : "memorisation";
  const p = PRODUCTS[id];
  const checkoutUrl = SHOPIFY_CHECKOUT[id];

  return (
    <div className="info-page" data-testid="checkout-page">
      <header className="info-header">
        <Link to="/guides" className="info-back" data-testid="back-guides-link">
          <ArrowLeft size={16} />
          Retour aux guides
        </Link>
        <Link to="/" className="logo logo-link" data-testid="brand-home-link" aria-label="SamNara — accueil"><img src="/logo-samnara.png" alt="SamNara" className="logo-img logo-img-lg" /></Link>
      </header>

      <div className="container checkout-wrap">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: EASE }}
        >
          <div className="eyebrow checkout-eyebrow">Finaliser ta commande</div>
          <h1 className="checkout-title">Récapitulatif</h1>

          <div className="checkout-panel" data-testid="checkout-summary">
            <div className="co-product">
              <div className="co-covers">
                {p.covers.map((c) => (
                  <BookCover key={c} variant={c} mini />
                ))}
              </div>
              <div>
                <b className="co-name" data-testid="checkout-product-name">{p.title}</b>
                <span className="co-sub">{p.sub}</span>
                <span className="co-format">Ebook PDF — livraison instantanée par téléchargement</span>
              </div>
            </div>

            <div className="co-lines">
              <div className="co-line">
                <span>Sous-total</span>
                <span>{p.oldPrice || p.price}</span>
              </div>
              {p.oldPrice && (
                <div className="co-line co-discount">
                  <span>Remise pack</span>
                  <span>− 9,99 €</span>
                </div>
              )}
              <div className="co-line co-total" data-testid="checkout-total">
                <span>Total</span>
                <b>{p.price}</b>
              </div>
            </div>

            {checkoutUrl ? (
              <a href={checkoutUrl} className="btn co-pay" data-testid="checkout-pay-btn">
                <ShoppingBag size={15} />
                Vérifier ma commande
              </a>
            ) : (
              <div className="co-pending" data-testid="checkout-pending">
                <p>Le Pack Gold arrive bientôt sur la boutique. Écris-nous pour le réserver au prix de lancement :</p>
                <a href="mailto:Bathilysamir22@gmail.com" className="btn co-pay" data-testid="checkout-contact-btn">
                  Réserver le pack
                </a>
              </div>
            )}

            <div className="co-note">
              <ShieldCheck size={15} />
              Paiement traité par Shopify — carte bancaire, PayPal et plus. Tes données bancaires ne passent jamais par ce site.
            </div>
          </div>

          <div className="assure-row co-assures">
            <div className="assure-item"><Zap size={16} /><span>Livraison instantanée</span></div>
            <div className="assure-item"><Lock size={16} /><span>Paiement sécurisé</span></div>
            <div className="assure-item"><InfinityIcon size={16} /><span>Accès à vie</span></div>
          </div>
        </motion.div>
      </div>

      <footer className="info-footer">
        <div className="copyright">
          © SamNara — Guides numériques, livraison instantanée après achat
        </div>
      </footer>
    </div>
  );
}
